module.exports = __webpack_public_path__ + "assets/img/67_313_3.5a45b1a5.jpg";